import { Button, Divider, Image, message, Modal, Space, Table, Tooltip } from "antd";
import moment from "moment-timezone";
import Overlay from "../Overlay";
import BusinessContactInfo from "../BusinessContactInfo";
import { useState } from "react";
import { useSession } from "../../utils/Session";
import { apiCall } from "../../utils/Api";

export default function TitlePubstockTab(props) {


    const [session, setSession] = useSession(); 
    const [loading, setLoading] = useState(false);
    const [requested, setRequested] = useState(false);
    const {
        pubstockData = [],
    } = props
    

    const smallText = (title) => {
        return (
            <small>{title}</small>
        )
    }


    const [pd, setPD] = useState(pubstockData);

    const drawOnOrderWithTooltip = () => {
        let _arr = [
            "ITO - Import To Order: must be imported, taking at least 2-6 weeks to get stock.",
            "Qwk - Quick: not stocked, but can get stock in less than 2 weeks.",
            "POD - Print On Demand: copies printed on demand.",
            "QPOD - Ships in 3-5 business days",
            "RP - Reprinting: the book is being reprinted by the publisher.",
            "NYR - Not Yet Received/Published: not yet received by the wholesaler, or published by the publisher.",
            "TOS - Temporarily out of stock: item will be in stock shortly.",
            "BOO - 'Backorder Only' title available as special order. ETA unknown.",
            "Mgd - Managed title: quantities shipped are managed manually"
        ]

        return (
            <Tooltip overlayInnerStyle={{ width: "550px" }} title={<>
                <div>Non-numeric O/O pubstock codes.</div>
                <div className="shim" />
                <div>
                    <small>
                        {_arr.map(item => {
                            return (<div>{item}</div>)
                        })}
                    </small>
                </div>
            </>}>
                <span style={{ "cursor": "pointer" }}><small>O/O</small></span>
            </Tooltip>
        )
    }

    const columns = [
        {
            title: smallText("Source"), dataIndex: "acct", key: "acct", render(e, f) {
                const flag_path = (f.country === "Canada") ? "https://bookmanager.com/i/CA.png" : "https://bookmanager.com/i/US.png";
                return (
                    <Space>
                        <Image
                            preview={false}
                            src={flag_path} />
                        <Overlay width={600} component={<div style={{ "padding": "20px" }}><strong>Contact</strong><Divider dashed style={{ "margin": "10px 0px" }} /><div className="shim" /><div style={{ "margin": "-8px" }}><BusinessContactInfo id={f.id} /></div></div>}><a style={{ "textAlign": "left", "maxWidth": "250px", "overflow": "hidden", "textOverflow": "ellipsis", "whiteSpace": "nowrap" }}>{e}</a></Overlay>
                    </Space>
                )
            }
        },
        {
            title: smallText("O/H"), dataIndex: "onhand", key: "onhand", render(e, f) {
                return f.onhand;
            }
        },
        {
            title: drawOnOrderWithTooltip(), dataIndex: "onorder", key: "onorder", render(e, f) {
                return drawOO(f.onorder);
            }
        },
        {
            title: <Tooltip title="Prices are in vendor's currency">{smallText("Price")}</Tooltip>, dataIndex: "supplier_price", key: "supplier_price", render(e, f) {
                return ("$" + f.supplier_price)
            }
        },
        {
            title: smallText("As Of"), dataIndex: "as_of", key: "as_of", render(e, f) {
                return moment(f.as_of * 1000).fromNow()
            }
        },
        {
            title: smallText("Returnable"), dataIndex: "returnable", key: "returnable"
        },
    ];

    const ColumnHelp = (props) => {
        return (
            <Tooltip title={props.title}>
                <span style={{ "cursor": "pointer" }} >{props.children}</span>
            </Tooltip>
        )
    }

    const drawOO = (_code) => {
        let msg = ""
        // eslint-disable-next-line default-case
        switch (_code) {
            case "ITO":
                msg = <>Import To Order<small><br />Must be imported, taking at least 2-6 weeks to get stock.</small></>
                break;
            case "Qwk":
                msg = <>Quick<small><br />Not stocked, but can get stock in less than 2 weeks.</small></>
                break;
            case "LOW":
                msg = <>LOW<small><br />Stock onhand is relatively low. Item may get backordered/cancelled.</small></>
                break;
            case "POD":
                msg = <>Print On Demand<small><br />Copies printed on demand.</small></>
                break;
            case "QPOD":
                msg = <>Quick Print On Demand<small><br />Ships in 3-5 business days</small></>
                break;
            case "RP":
                msg = <>Reprinting<small><br />The book is being reprinted by the publisher.</small></>
                break;
            case "NYR":
                msg = <>Not Yet Received / Published<small><br />Not received by the wholesaler or published by the publisher.</small></>
                break;
            case "TOS":
                msg = <>Temporarily out of stock<small><br />Item will be in stock shortly.</small></>
                break;
            case "BOO":
                msg = <>Backorder Only<small><br />Title available as a special order. ETA unknown.</small></>
                break;
            case "Mgd":
                msg = <>Managed Title<small><br />Quantities shipped are managed manually.</small></>
                break;
        }
        if (msg) {
            return (<ColumnHelp title={msg}>{_code}</ColumnHelp>)
        }
        return _code;
    }

    
    const fetchPubstock = () => {
        setLoading(true)
        apiCall("title/getPubstock", {isbn : props.isbn}, (_s, _r) => {
            if(_s){
                setPD(_r)
            } else {
                Modal.warning(
                    {
                        title : "Sorry...",
                        content : <>We are unable to fulfill your Pubstock request as you have reached the maximum number of lookups allowed for casual usage. <br /><br /> Please contact us at 250-763-4415 or <a href="mailto:data@bookmanager.com">data@bookmanager.com</a> for more information, or unlimited access.</>
                    }
                )
            }
            setRequested(true);
           setLoading(false)
        })
    }

    const getLocale = () => {

        if(requested){
            return false; 
        }

        if(session?.subscriptions?.pubstock){
            return false;
        }

        return (
            {
                emptyText: (
                    <div style={{ textAlign: 'center' }}>
                        <br />
                        <p>PubStock requests are limited. Increased lookups require an annual subscription. Please contact us at <a href="mailto:data@bookmanager.com">data@bookmanager.com</a> for more information.</p>
                        {/* <Button  size="small" type="primary" onClick={() => fetchPubstock()}>
                            <small>Request</small>
                        </Button> */}
                        <br /> <br />
                    </div>
                )
            }
        )

    }

    return (
        <Table
            size="small"
            columns={columns}
            loading={loading}
            locale={getLocale()}
            dataSource={pd}
            pagination={false}
        />
    )
}